import type { FolderApi } from 'tweakpane';
import { waitForNextFrame } from '../../../../utils/async-utils';

export function createListHandler(folderApi: FolderApi, target: (string | number)[], type: 'string' | 'number'): void {
  const temp = {
    value: type === 'string' ? '' : 0,
  };

  function refresh(): void {
    folderApi.children.slice().forEach(async (child) => {
      await waitForNextFrame();
      child.dispose();
    });

    for (let i = 0; i < target.length; i += 1) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      folderApi.addBinding(target, `${i}`).on('change', (ev) => {
        if (ev.value === '' || ev.value === 0) {
          target.splice(i, 1);
          refresh();
        }
      });
    }

    folderApi
      .addBinding(temp, 'value', {
        label: 'New value',
      })
      .on('change', (ev) => {
        console.log(ev);
        if (ev.value !== '' && ev.value !== 0) {
          target.push(ev.value);
          temp.value = type === 'string' ? '' : 0;
          refresh();
        }
      });
  }

  refresh();
}
